import React, {Component} from 'react';
import * as func from "../../../../../utils/functions";
import {objectToQueryString} from "../../../../../utils/functions";
import ResourceItem from "../../list/Resourceitem";
import {BASE_PATH} from "../../../../../wpconfig";
import {NavLink} from 'react-router-dom'

class RAlticle extends Component {
	constructor(props) {
		super(props);

		let scholar_id = []
		if (rmVars.org_name) {
			if(this.props.record.author[rmVars.org_name]) {
				this.props.record.author[rmVars.org_name].map((author, index) => {
					scholar_id.push(author.scholar_id)
				})
			}
		}

		this.state = {
			isInit: false,
			param: {
				"not_resource_id": this.props.record.resource_id,
				"scholar_id": scholar_id,
				'order_by': 'date',
				'order': 'desc',
				'record_per_page': 3,
				'current_page': 1
			},
			records: [],
			totalRecords: 0
		}

		const param = this.state.param;
		if(param.scholar_id.length > 0) {
			func.getData("resources", param).then((response) => {
				this.setState({isInit: true, 'records': response.records})
			});
		}
	}

	changeTab = (id) => {
		this.setState({
			activeTab: id
		})
	}

	render() {
		if (!this.state.isInit)
			return ''
		const records = this.state.records;

		const url = objectToQueryString({
			'not_resource_id' : this.state.param.not_resource_id,
			'scholar_id' : this.state.param.scholar_id,
		});

		return (
			<div className="mt-6">
				<div className="d-flex justify-content-between align-items-center mb-px-26">
					<div className="d-flex align-items-center">
						<h3 className="con-title">저자가 발표한 다른 논문</h3>
					</div>
				</div>
				{records.length > 0 ?
				<>
					<div>
						<div className="line-list-group">
							{records.map((record, index) => {
								return (
									<ResourceItem key={index} record={record}/>
								)
							})}
						</div>
					</div>
					<div className="mt-4">
						<div className="text-center">
							<NavLink to={BASE_PATH + 'resources/?' + url}
							         className="btn btn-outline-gray btn-lg">
								<span className="icon icon-size-24 icon-plus-black align-top mr-2"/><strong>논문 전체보기</strong>
							</NavLink>
						</div>
					</div>
				</>
				: <div className="mt-4">
						<div className="text-center">
							<div className="btn-outline-gray btn-lg">결과가 없습니다.</div>
						</div>
					</div>
				}
			</div>
		);
	};
}

export default RAlticle;
